import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://fnvrzcuswoqulolinspp.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZudnJ6Y3Vzd29xdWxvbGluc3BwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk3MTk3MzQsImV4cCI6MjA4NTI5NTczNH0.2Vl8AKap3r8kqVz6bRNCGM4NzEEwLn8BGHdk0uYRZac';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Track a listing view
export const trackListingView = async (listingId) => {
  try {
    // First, try to get existing record
    const { data: existing } = await supabase
      .from('listing_views')
      .select('*')
      .eq('listing_id', listingId)
      .single();

    if (existing) {
      // Update existing count
      await supabase
        .from('listing_views')
        .update({ view_count: existing.view_count + 1 })
        .eq('listing_id', listingId);
    } else {
      // Insert new record
      await supabase
        .from('listing_views')
        .insert({ listing_id: listingId, view_count: 1 });
    }
  } catch (error) {
    console.error('Error tracking view:', error);
  }
};

// Get view count for a listing
export const getListingViews = async (listingId) => {
  try {
    const { data } = await supabase
      .from('listing_views')
      .select('view_count')
      .eq('listing_id', listingId)
      .single();
    return data?.view_count || 0;
  } catch (error) {
    return 0;
  }
};

// Get all view counts
export const getAllListingViews = async () => {
  try {
    const { data } = await supabase
      .from('listing_views')
      .select('listing_id, view_count');
    return data || [];
  } catch (error) {
    console.error('Error fetching views:', error);
    return [];
  }
};
